/* 見出し */
import React from 'react';

interface Props {
  label: string;
}

const HeadingM: React.FC<Props> = ({ label }) => {
  return (
    <div className="heading-m-box">
      <h3 className="heading-m">{label}</h3>
    </div>
  );
};

export default HeadingM;
